import { render, staticRenderFns } from "./AddTruckEventModal.vue?vue&type=template&id=5e6d81f0"
import script from "./AddTruckEventModal.vue?vue&type=script&lang=js"
export * from "./AddTruckEventModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports